import { CircuitDayFormData } from '@/types/circuits/CircuitDaysFormData';
import { hasActiveAssociatedBenefits } from './hasActiveAssociatedBenefits';

export const isRowReservedForAssociatedBenefits = (
  step: CircuitDayFormData['steps'][number],
): boolean => {
  const { accommodations } = step;
  if (hasActiveAssociatedBenefits(accommodations?.standardBenefit?.hotel)) {
    return true;
  }

  return (accommodations?.optionalBenefits ?? []).some((benefit) =>
    hasActiveAssociatedBenefits(benefit.hotel),
  );
};
